// extracted by mini-css-extract-plugin
module.exports = {"segmentTabsWrapper":"segmentTabsWrapper-1fJ0m"};